import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EventCategoryForm } from "./EventCategoryForm";

interface EventCategoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categoryId?: string | null;
}

export function EventCategoryModal({ open, onOpenChange, categoryId }: EventCategoryModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {categoryId ? "Edit Event Category" : "Add New Event Category"}
          </DialogTitle>
        </DialogHeader>
        <EventCategoryForm
          categoryId={categoryId}
          onClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}